import React, { useState, useEffect } from 'react';
import { Grid, Typography, IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import api from '../../../services/api';
import Input from '../../TextInput';
import Button from '../../Button';
import { StyledDialogEdit } from '../styles';

export default function AccountUpdateModal({
  open,
  onClose,
  isPayable,
  user,
  canClose,
  onSaved,
}) {
  const [name, setName] = useState('');
  const [shopName, setShopName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!user) return;
    setName(isPayable ? user.payName : user.name);
    setPhone(isPayable ? user.payPhone : user.phone);
    setEmail(isPayable ? user.payEmail : user.email);
    setShopName(user.shopName);
  }, [isPayable, user, open]);

  const handleUpdate = async () => {
    const data = new FormData();
    data.append('email', user ? user.email : '');
    if (isPayable) {
      data.append('payName', name);
      data.append('payPhone', phone);
      data.append('payEmail', email);
    } else {
      if (email !== (user && user.email)) {
        data.append('newEmail', email);
      }
      data.append('name', name);
      data.append('phone', phone);
      data.append('shopName', shopName);
    }
    const response = await api.put('/newCostumers', data);
    if (response && response.data && response.data.msg) {
      // eslint-disable-next-line no-alert
      return alert(response.data.msg);
    }
    return onSaved();
  };

  return (
    <StyledDialogEdit
      BackdropProps={{ style: { borderRadius: 15 } }}
      open={open}
      onClose={onClose}
      style={{
        width: 350,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2000,
      }}
    >
      <Grid style={{ padding: '5%', width: 350 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography>
            {!isPayable ? 'Account Information' : 'Account Payable'}
          </Typography>
          {canClose && (
            <IconButton onClick={onClose}>
              <ClearIcon />
            </IconButton>
          )}
        </Grid>
        {!isPayable && (
          <Input
            field="Shop name"
            width={320}
            height={43}
            marginTop={40}
            value={shopName}
            onChange={event => setShopName(event.target.value)}
          />
        )}
        <Input
          field="Name"
          width={320}
          height={43}
          marginTop={20}
          value={name}
          onChange={event => setName(event.target.value)}
        />
        <Input
          field="Email"
          width={320}
          height={43}
          marginTop={40}
          value={email}
          onChange={event => setEmail(event.target.value)}
        />
        <Input
          field="Phone"
          width={320}
          height={43}
          marginTop={40}
          value={phone}
          onChange={event => setPhone(event.target.value)}
        />
        <Grid container justifyContent="center" style={{ paddingBottom: 44 }}>
          <Button
            justifyContent="center"
            width={128}
            height={40}
            color="#000000"
            textColor="#FFFFFF"
            text="save"
            marginTop={54}
            fontSize={16}
            onClick={handleUpdate}
          />
        </Grid>
      </Grid>
    </StyledDialogEdit>
  );
}
